import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const ShatterAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number,
  globalHue: number,
  cam?: { x: number, y: number, scale: number },
  width?: number,
  height?: number
) => {
  const easedProgress = 1 - Math.pow(1 - progress, 2);
  const count = 20;

  // Optimization: Pre-calculate screen bounds in world space if needed
  let minX = -Infinity, maxX = Infinity, minY = -Infinity, maxY = Infinity;
  const usePartialOpt = config.enableFrustumCulling && config.partialRingBlastOptimization && cam && width && height;
  if (usePartialOpt) {
      const halfW = width / 2;
      const halfH = height / 2;
      const scale = cam.scale || 1;
      const margin = config.frustumCullingMargin || 100;
      minX = -halfW / scale - cam.x - margin;
      maxX = halfW / scale - cam.x + margin;
      minY = -halfH / scale - cam.y - margin;
      maxY = halfH / scale - cam.y + margin;
  }

  for (let i = 0; i < count; i++) {
      const angle = (i / count) * Math.PI * 2 + (i * 0.5);
      const distBase = e.maxRadius + easedProgress * 150;
      const r = getRadiusAtAngle(angle, e, distBase);
      
      const wx = e.pos.x + Math.cos(angle) * r;
      const wy = e.pos.y + Math.sin(angle) * r;

      if (usePartialOpt) {
          if (wx < minX || wx > maxX || wy < minY || wy > maxY) continue;
      }

      const sx = clampX(wx);
      const sy = clampY(wy);
      ctx.save(); ctx.translate(sx, sy); ctx.rotate(progress * 10);
      const size = 12 * (1-progress);
      ctx.beginPath(); ctx.rect(-size/2, -size/2, size, size); ctx.fill(); ctx.restore();
  }
};

registerBlastAnimation('SHATTER', ShatterAnimation);
